import { render, staticRenderFns } from "./EditReferral.vue?vue&type=template&id=33c00628&"
import script from "./EditReferral.vue?vue&type=script&lang=js&"
export * from "./EditReferral.vue?vue&type=script&lang=js&"
import style0 from "./EditReferral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports